import Api from "./Api";

class ToppageAPI extends Api{

    listLatest10(){

        let path = "/toppage/latest10";

        let endpoint =  this.combineUrl(this.apiHost,path);

        return this._get(endpoint).then(response =>  response)        
    }

}

let _api = new ToppageAPI();

export default _api;